import { Main } from "../../../components"

export const Licitacoes = () => {
  return (
    <Main>
      <section className="services">
        <div className="container padding-top-bottom" data-aos="fade-up">
          <div className="row">
            <div className="section-title">
              <h2>Licitações</h2>
            </div>

            <div className="row">
              <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
                <a href="https://drive.google.com/file/d/1feEw5O0EMlZkvovXArabU20Sk0zXfxaE/view?usp=sharing"
                  target="_blank" rel="noreferrer">
                  <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                    <div className="icon">
                      <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                    </div>
                    <h4>Edital de Compras - UNIFORMES - 2023</h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
                <a href="https://drive.google.com/file/d/1j8CohsulquC3uJzUR1Z8LJCRYrCJXu_d/view?usp=sharing"
                  target="_blank" rel="noreferrer">
                  <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                    <div className="icon">
                      <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                    </div>
                    <h4>Edital de Prestação de Serviços - Assessoria e Contador</h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
                <a href="https://drive.google.com/file/d/1P6QlcsdK21BcZTyJrPBIzjWZTZsH-BDU/view?usp=sharing"
                  target="_blank" rel="noreferrer">
                  <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                    <div className="icon">
                      <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                    </div>
                    <h4>Edital de Compras - NOTEBOOK - 2023</h4>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Main>
  )
}